import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M11.48 3.501a.562.562 0 0 1 1.04 0l2.125 5.111a.56.56 0 0 0 .475.345l5.518.443c.499.04.701.662.321.987l-4.204 3.602a.56.56 0 0 0-.182.558l1.285 5.384a.562.562 0 0 1-.84.611l-4.725-2.886a.56.56 0 0 0-.586 0l-4.725 2.886a.562.562 0 0 1-.84-.61l1.285-5.385a.56.56 0 0 0-.182-.558l-4.204-3.602a.563.563 0 0 1 .321-.987l5.518-.443a.56.56 0 0 0 .475-.345z"
    }, null, -1)
  ])))
}
export default { render: render }